/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { skillsListUnknownActivations } from "../funcs/skillsListUnknownActivations.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListUnknownSkillActivationsRequest,
  ListUnknownSkillActivationsResponse,
  ListUnknownSkillActivationsSecurity,
} from "../models/operations/listunknownskillactivations.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type UnknownSkillActivationsQueryData =
  ListUnknownSkillActivationsResponse;

export type UnknownSkillActivationsInfiniteQueryData = PageIterator<
  ListUnknownSkillActivationsResponse,
  { cursor: string }
>;

export type UnknownSkillActivationsPageParams = PageIterator<
  ListUnknownSkillActivationsResponse,
  { cursor: string }
>["~next"];

export function prefetchUnknownSkillActivations(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUnknownSkillActivationsRequest | undefined,
  security?: ListUnknownSkillActivationsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUnknownSkillActivationsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchUnknownSkillActivationsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUnknownSkillActivationsRequest | undefined,
  security?: ListUnknownSkillActivationsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildUnknownSkillActivationsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as UnknownSkillActivationsPageParams,
    getNextPageParam: (
      previousPage: UnknownSkillActivationsInfiniteQueryData,
    ) => previousPage["~next"],
  });
}

export function buildUnknownSkillActivationsQuery(
  client$: GramCore,
  request?: ListUnknownSkillActivationsRequest | undefined,
  security?: ListUnknownSkillActivationsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UnknownSkillActivationsQueryData>;
} {
  return {
    queryKey: queryKeyUnknownSkillActivations({
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function unknownSkillActivationsQueryFn(
      ctx,
    ): Promise<UnknownSkillActivationsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(skillsListUnknownActivations(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildUnknownSkillActivationsInfiniteQuery(
  client$: GramCore,
  request?: ListUnknownSkillActivationsRequest | undefined,
  security?: ListUnknownSkillActivationsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, UnknownSkillActivationsPageParams>,
  ) => Promise<UnknownSkillActivationsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyUnknownSkillActivationsInfinite({
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function unknownSkillActivationsQuery(
      ctx,
    ): Promise<UnknownSkillActivationsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          skillsListUnknownActivations(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        skillsListUnknownActivations(
          client$,
          {
            ...request!,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyUnknownSkillActivations(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "skills", "listUnknownActivations", parameters];
}

export function queryKeyUnknownSkillActivationsInfinite(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "skills",
    "listUnknownActivations",
    "infinite",
    parameters,
  ];
}
